<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

interface Props {
  align?: string
  width?: string
  contentClasses?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  align: 'right',
  width: '48',
  contentClasses: () => [
    'py-1',
    'bg-white',
    'lg:bg-white/75',
    ' lg:backdrop-blur-xs',
    'dark:bg-neutral-700/95 lg:dark:bg-neutral-700/50',
  ],
})

const open = ref(false)

// const closeOnEscape = (e) => {
//   if (open.value && e.keyCode === 27) {
//     open.value = false
//   }
// }

// onMounted(() => document.addEventListener('keydown', closeOnEscape))
// onUnmounted(() => document.removeEventListener('keydown', closeOnEscape))

const widthClass = computed(() => ({
  '48': 'w-48',
}))

const alignmentClasses = computed(() => {
  if (props.align === 'left') {
    return 'origin-top-left left-0'
  } else if (props.align === 'right') {
    return 'origin-top-right right-0'
  } else {
    return 'origin-top'
  }
})
</script>

<template>
  <div class="relative">
    <div @click="open = !open">
      <slot name="trigger"></slot>
    </div>

    <!-- Full Screen Dropdown Overlay -->
    <div v-show="open" class="fixed inset-0 z-40" @click="open = false"></div>

    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-show="open"
        class="fixed lg:absolute z-50 top-0 lg:top-8 w-full lg:w-auto mt-2 rounded-md shadow-lg"
        :class="[widthClass, alignmentClasses]"
        style="display: none"
        @click="open = false"
      >
        <div
          class="rounded-md ring-1 ring-black/5"
          :class="contentClasses"
        >
          <slot name="content"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>
